// ═══════════════════════════════════════════════
//   EMAIL BLITZ — minigame
// ═══════════════════════════════════════════════
//
// Objective:   Sort flying emails into KEEP (left half) or SPAM (right half)
//              by clicking the correct side.
// Type:        click-react
// Description: Click each email on the matching half. Wrong sorts cost 1 HP
//              (GAME_EMAILS.hp total) and break the combo. Speed and
//              double-spawn chance ramp every GAME_EMAILS.tierEvery score
//              points; round ends on timer or HP loss. Reward is per
//              end-of-run sorted-count.
// Tunables:    GAME_EMAILS in data.js.

const {canvas, ctx, claimGameReward, addCleanup, showGameOver} = window;

const EM_DATA = [
    {t: 'Invoice #3847',        from: 'warehouse@konbini.bun',  spam: false, color: '#dff5e1'},
    {t: 'WIN $1000!!!',         from: 'totallyreal@crypto.xyz', spam: true,  color: '#fde8e8'},
    {t: 'Delivery update',      from: 'shipping@bun.net',       spam: false, color: '#dff5e1'},
    {t: 'Enlarge ur store!!!',  from: 'spam@spamspam.com',      spam: true,  color: '#fde8e8'},
    {t: 'Staff meeting 10am',   from: 'manager@konbini.bun',    spam: false, color: '#dff5e1'},
    {t: 'You are WINNER',       from: 'no-reply@fake.ru',       spam: true,  color: '#fde8e8'},
    {t: 'New supplier offer',   from: 'supplierA@mail.bun',     spam: false, color: '#dff5e1'},
    {t: 'FREE GACHAPON CODES',  from: 'hacker@lol.net',         spam: true,  color: '#fde8e8'},
    {t: 'Tomorrow schedule',    from: 'hr@konbini.bun',         spam: false, color: '#dff5e1'},
    {t: 'Claim ur prize now',   from: 'prize@totally.biz',      spam: true,  color: '#fde8e8'},
    {t: 'Restock request',      from: 'stock@konbini.bun',      spam: false, color: '#dff5e1'},
    {t: 'Hot singles near u!',  from: 'dating@scam.net',        spam: true,  color: '#fde8e8'},
    {t: 'Payroll processed',    from: 'finance@konbini.bun',    spam: false, color: '#dff5e1'},
    {t: 'Ur acct was hacked',   from: 'security@fake-bank.cc',  spam: true,  color: '#fde8e8'},
    {t: 'Health inspection OK', from: 'city@health.gov',        spam: false, color: '#dff5e1'},
    {t: 'Double ur profits!!',  from: 'guru@money.biz',         spam: true,  color: '#fde8e8'},
    {t: 'Opening hrs update',   from: 'ops@konbini.bun',        spam: false, color: '#dff5e1'},
    {t: 'CLICK HERE NOW!!!',    from: 'noreply@virus.exe',      spam: true,  color: '#fde8e8'},
    {t: 'Product recall notice',from: 'safety@konbini.bun',     spam: false, color: '#dff5e1'},
    {t: 'Nigerian prince needs',from: 'prince@nigeria.biz',     spam: true,  color: '#fde8e8'},
    {t: 'Vendor contract due',  from: 'legal@konbini.bun',      spam: false, color: '#dff5e1'},
    {t: 'Ur PC has a virus!!',  from: 'alert@microsaft.net',    spam: true,  color: '#fde8e8'},
];

window.emEmails = [];
let emCombo = 0;
let emHP = 0;

function startEmails() {
    const CFG = window.GAME_EMAILS;
    window.emEmails = [];
    emCombo = 0;
    emHP = CFG.hp;
    window.gameTimer = CFG.timer;
    window.gameScore = 0;
    window.gameRunning = true;
    document.getElementById('mg-timer').textContent = CFG.timer + 's';
    document.getElementById('mg-score').textContent = '0';

    window.spawnInterval = setInterval(() => {
        if (!window.gameRunning) return;
        const tier = Math.floor(window.gameScore / CFG.tierEvery);
        const spd = () => (CFG.speedBase + tier * CFG.speedTierStep) * (0.75 + Math.random() * 0.6);
        const pick = () => ({
            ...EM_DATA[Math.floor(Math.random() * EM_DATA.length)],
            x: canvas.width + 20,
            y: 60 + Math.random() * (canvas.height - 130),
            w: 160, h: 52,
            speed: spd(),
            clicked: false, flash: 0
        });
        window.emEmails.push(pick());
        if (Math.random() < Math.min(CFG.doubleChanceMax, tier * CFG.doubleChanceStep)) {
            const extra = pick();
            extra.y = 60 + Math.random() * (canvas.height - 130);
            window.emEmails.push(extra);
        }
    }, CFG.spawnEvery);
    addCleanup(() => clearInterval(window.spawnInterval));

    window.timerInterval = setInterval(() => {
        window.gameTimer--;
        document.getElementById('mg-timer').textContent = window.gameTimer + 's';
        if (window.gameTimer <= 0) endEmails();
    }, 1000);
    addCleanup(() => clearInterval(window.timerInterval));

    window.gameInterval = setInterval(emLoop, 16);
    addCleanup(() => clearInterval(window.gameInterval));

    canvas.addEventListener('pointerdown', emClick);
    addCleanup(() => canvas.removeEventListener('pointerdown', emClick));
    addCleanup(() => { window.emEmails = []; });
}

function emClick(e) {
    if (!window.gameRunning) return;
    const CFG = window.GAME_EMAILS;
    const {x: mx, y: my} = canvasPos(e);
    for (let i = window.emEmails.length - 1; i >= 0; i--) {
        const m = window.emEmails[i];
        if (m.clicked) continue;
        const px = m.x - m.w / 2, py = m.y - m.h / 2;
        if (mx >= px && mx <= px + m.w && my >= py && my <= py + m.h) {
            const markedSpam = mx > canvas.width / 2;
            m.clicked = true;
            m.flash = 10;
            if (markedSpam === m.spam) {
                emCombo++;
                const mult = emCombo >= CFG.comboHigh ? 3 : emCombo >= CFG.comboLow ? 2 : 1;
                window.gameScore += mult;
                document.getElementById('mg-score').textContent = window.gameScore;
                m.flashColor = '#a8e063';
                m.multLabel = mult > 1 ? `×${mult}` : null;
                SFX.play(mult > 1 ? 'pts' : 'hit');
            } else {
                emCombo = 0;
                window.gameScore = Math.max(0, window.gameScore - 1);
                document.getElementById('mg-score').textContent = window.gameScore;
                m.flashColor = '#f44336';
                SFX.play('error');
                emHP--;
                if (emHP <= 0) {
                    m.flash = 0;
                    endEmails();
                    return;
                }
            }
            break;
        }
    }
}

function emLoop() {
    if (!window.gameRunning) return;
    const CFG = window.GAME_EMAILS;
    const W = canvas.width, H = canvas.height;

    ctx.fillStyle = '#1a1a2e';
    ctx.fillRect(0, 0, W, H);

    // zone backgrounds
    ctx.fillStyle = 'rgba(168,224,99,0.22)';
    ctx.fillRect(0, 0, W / 2, H);
    ctx.fillStyle = 'rgba(244,67,54,0.14)';
    ctx.fillRect(W / 2, 0, W / 2, H);

    // zone labels
    ctx.font = 'bold 9px "Press Start 2P",monospace';
    ctx.textAlign = 'center';
    ctx.fillStyle = '#a8e063';
    ctx.fillText('✓ KEEP', W / 4, H - 12);
    ctx.fillStyle = '#f44336';
    ctx.fillText('✗ SPAM', W * 3 / 4, H - 12);

    // divider
    ctx.setLineDash([6, 4]);
    ctx.strokeStyle = 'rgba(255,255,255,0.2)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(W / 2, 0);
    ctx.lineTo(W / 2, H);
    ctx.stroke();
    ctx.setLineDash([]);

    // emails
    window.emEmails = window.emEmails.filter(m => {
        if (!m.clicked) m.x -= m.speed;
        if (m.flash > 0) m.flash--;
        const px = m.x - m.w / 2, py = m.y - m.h / 2;

        ctx.save();
        if (m.flash > 0) {
            ctx.globalAlpha = 0.65 + Math.sin(m.flash * 0.9) * 0.35;
            ctx.fillStyle = m.flashColor;
        } else {
            ctx.fillStyle = m.color;
        }
        ctx.beginPath();
        ctx.roundRect(px, py, m.w, m.h, 8);
        ctx.fill();
        ctx.strokeStyle = m.spam ? '#f44336' : '#4caf50';
        ctx.lineWidth = 2;
        ctx.stroke();
        ctx.globalAlpha = 1;

        ctx.fillStyle = '#111';
        ctx.font = 'bold 10px sans-serif';
        ctx.textAlign = 'left';
        ctx.fillText(m.t.slice(0, 20), px + 8, py + 18);
        ctx.font = '8px sans-serif';
        ctx.fillStyle = '#555';
        ctx.fillText(m.from.slice(0, 24), px + 8, py + 32);

        ctx.font = 'bold 9px "Press Start 2P",monospace';
        ctx.textAlign = 'center';
        ctx.fillStyle = m.spam ? '#f44336' : '#4caf50';
        ctx.fillText(m.spam ? 'SPAM' : 'KEEP', m.x, py + m.h - 6);

        // multiplier badge
        if (m.multLabel && m.flash > 0) {
            ctx.font = 'bold 13px "Press Start 2P",monospace';
            ctx.fillStyle = '#ffe066';
            ctx.textAlign = 'center';
            ctx.fillText(m.multLabel, m.x + m.w / 2 - 10, py - 6);
        }

        ctx.restore();
        if (m.clicked && m.flash <= 0) return false;
        if (!m.clicked && m.x < -m.w) return false;
        return true;
    });

    // HP hearts
    ctx.font = '15px serif';
    ctx.textAlign = 'left';
    for (let i = 0; i < CFG.hp; i++) {
        ctx.globalAlpha = i < emHP ? 1 : 0.2;
        ctx.fillStyle = '#f44336';
        ctx.fillText('♥', 8 + i * 20, 22);
    }
    ctx.globalAlpha = 1;

    // combo streak indicator
    if (emCombo >= CFG.comboLow) {
        const mult = emCombo >= CFG.comboHigh ? 3 : 2;
        ctx.font = 'bold 8px "Press Start 2P",monospace';
        ctx.textAlign = 'center';
        ctx.fillStyle = '#ffe066';
        ctx.fillText(`COMBO ×${mult}  (${emCombo} streak)`, W / 2, 14);
    }

    // score top-right
    ctx.font = '7px "Press Start 2P",monospace';
    ctx.textAlign = 'right';
    ctx.fillStyle = '#7dd3fc';
    ctx.fillText('sorted: ' + window.gameScore, W - 6, 14);
}

function endEmails() {
    const CFG = window.GAME_EMAILS;
    window.gameRunning = false;
    SFX.play(emHP <= 0 ? 'gameover' : 'win');
    const p = Math.min(CFG.rewardMax, window.gameScore * CFG.rewardPer);
    const reason = emHP <= 0 ? 'You got overwhelmed!' : 'Time\'s up!';
    showGameOver(`${reason}\nSorted: ${window.gameScore}\n` + claimGameReward('emails', window.gameScore, p));
}

window.startEmails = startEmails;
window.emClick = emClick;
window.endEmails = endEmails;
